import { useQuery } from '@hooks/reactQuery';

import { portalMilestones } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getPortalMilestones } from '@api/portalMilestones';

import { extractQueryParams } from '@utils/common';

import { IItemsResponse } from '@interfaces/common/response';
import { IPortalMilestoneDTO } from '@interfaces/portal/dto/milestonesManagementDTO';

import { GET_PORTAL_MILESTONES } from '@constants/queryKeys';

interface IUseQueryPortalMilestonesReturned {
	isLoadingPortalMilestones: boolean;
	countOfRecords: number;
	portalMilestones: Array<IPortalMilestoneDTO>;
}

export const useQueryPortalMilestones = (projectId?: string): IUseQueryPortalMilestonesReturned => {
	const {
		page,
		pageSize,
		searchValue,
		sortFieldName,
		sortDirection,
		status,
		assignees,
	} = useAppSelector(portalMilestones);

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IItemsResponse<IPortalMilestoneDTO>>({
			queryKey: [
				GET_PORTAL_MILESTONES,
				{
					page,
					pageSize,
					searchValue,
					sortFieldName,
					sortDirection,
					status,
					projectId,
					assignees,
				},
			],
			queryFn: extractQueryParams(getPortalMilestones),
			enabled: [!!projectId],
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 0,
		},
	);

	return {
		isLoadingPortalMilestones: isLoading || isFetching,
		portalMilestones: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
